<script setup lang='ts'>
import '@globalhive/vuejs-tour/dist/style.css'
import { VTour } from '@globalhive/vuejs-tour'

const router = useRouter()
// stores
const guideStore = useGuideStore()
const appStore = useAppStore()
// re0fs
const {
  tour,
  steps,
} = storeToRefs(guideStore)

// methods
const { reset } = guideStore
function endTourAndReset(props: any, endTour: any) {
  endTour()
  reset()
  router.push('/dashboard')
  document.querySelector<HTMLButtonElement>('.bcu-footer-left button')?.click()
}

async function lastStepCustom(props: any, lastStep: any) {
  if (typeof props.getCurrentStep.backStep === 'string') {
    appStore.setSnackbar({
      active: true,
      message: 'Please restart tour to go back',
      timeout: 5000,
      type: 'error',
    })
    return
  }
  else if (props.getCurrentStep.backStep) {
    await props.getCurrentStep.backStep()
  }
  lastStep()
}
// watchers
</script>

<template>
  <VTour
    v-if="tour"
    auto-start
    backdrop
    highlight
    :steps="steps"
  >
    <template #actions="{ lastStep, nextStep, endTour, _CurrentStep, getNextLabel, props }">
      <div class="vjt-actions">
        <v-btn
          v-if="_CurrentStep.lastStep < _CurrentStep.currentStep"
          :text="props.buttonLabels?.back || 'Back'"
          type="button"
          @click.prevent="lastStepCustom(_CurrentStep, lastStep)"
        />
        <v-btn
          v-if="getNextLabel === 'Done'"
          text="Im Done"
          type="button"
          @click.prevent="endTourAndReset(props, endTour)"
        />
        <v-btn
          v-else
          :text="getNextLabel"
          type="button"
          @click.prevent="nextStep()"
        />
      </div>
    </template>
  </VTour>
</template>

<style lang="sass">
.vjt-actions
  button
    width: auto
</style>
